<template>
  <div class="sidebar">
    <el-menu
      class="sidebar-el-menu"
      :default-active="onRoutes"
      :collapse="collapse"
      background-color="#324157"
      text-color="#bfcbd9"
      active-text-color="#20a0ff"
      unique-opened
      router
    >
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index">
            <template #title>
              <i class="el-icon">
                <component v-bind:is="item.icon"></component>
              </i>
              <span>{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu
                v-if="subItem.subs"
                :index="subItem.index"
                :key="subItem.index"
              >
                <template #title>{{ subItem.title }}</template>
                <el-menu-item
                  v-for="(threeItem, i) in subItem.subs"
                  :key="i"
                  :index="threeItem.index"
                  >{{ threeItem.title }}</el-menu-item
                >
              </el-submenu>
              <el-menu-item
                v-else
                :index="subItem.index"
                :key="subItem.index"
                >{{ subItem.title }}</el-menu-item
              >
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <i class="el-icon">
              <component v-bind:is="item.icon"></component>
            </i>
            <template #title>{{ item.title }}</template>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          icon: "home-filled",
          index: "dashboard",
          title: "Home",
        },
        {
          icon: "user-filled",
          index: "studentList",
          title: "Students",
        },
        {
          icon: "reading",
          index: "courseList",
          title: "Courses",
        },
        {
          icon: "notebook",
          index: "lessonList",
          title: "Lessons",
        },
        {
          icon: "house",
          index: "classRoomList",
          title: "ClassRooms",
        },
        {
          icon: "histogram",
          index: "testReportList",
          title: "Test Reports",
        },
        {
          icon: "money",
          index: "receiptList",
          title: "Receipts",
        },
        {
          icon: "coin",
          index: "pointsRecordList",
          title: "Points Issued List",
        },
        {
          icon: "user",
          index: "userList",
          title: "Users",
        },
        {
          icon: "postcard",
          index: "emailTemplateList",
          title: "Email Templates",
        },
        {
          icon: "message",
          index: "sendingEmail",
          title: "Sending Email",
        },
        {
          icon: "setting",
          index: "settings",
          title: "Global Settings",
        },
        {
          icon: "monitor",
          index: "userLogs",
          title: "User Logs",
        },
      ],
    };
  },
  computed: {
    onRoutes() {
      return this.$route.path;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
};
</script>

<style scoped>
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 70px;
  bottom: 0;
  overflow-y: scroll;
  background-color: #324157;
}
.sidebar::-webkit-scrollbar {
  width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
  width: 180px;
}
.sidebar > ul {
  height: 100%;
}
</style>
